// Kdo řídí výpis kategorie: nativní Shoptet (výchozí), nebo vlastní index.
//
// Toolbar (listingTools.js), filtr a hlavička (categoryPage.js) i mobilní lišta
// (mobileFilter.js) čtou stav výpisu z nativního DOM: `.listSorting`, zaškrtnuté
// inputy `#filters`, „Stránka X z Y". Procházení výprodeje (saleBrowse.js) kreslí
// výpis z vlastního indexu a nativní stav pak lže. Moduly se proto nejdřív ptají
// tady; bez zdroje (všude jinde, i ve fallbacku na nativ) jedou dnešní cestou.
//
// Zdroj = objekt s metodami:
//   stats()          {page, pages, total, rendered} jako listingStats()
//   sortOptions()    [{label, active, activate()}] jako listingTools.sortOptions()
//   activeFilters()  [{label, remove()}]
//   clearFilters()   zruší filtry panelu

let current = null;

export function setListingSource(source) {
  current = source || null;
}

export function listingSource() {
  return current;
}
